import React from 'react'
import i18n from 'live/services/i18n'
import authorization from 'live/services/authorization'
import Router from 'live/services/router'

import { withSuspenseWrapper } from '../../components/SuspenseWrapper'

import { ptBr } from '../../../i18n/pt_br'
import { enUs } from '../../../i18n/en_us'

const WrapperDynamicDashboardGlobalSendPage = withSuspenseWrapper(
    React.lazy(() => import('../components/Table/DataUnifierPage/DynamicDashboardGlobalSendPage'))
)

const locale = Live.settings && Live.settings.locale ? Live.settings.locale : 'pt_br'
const localeFiles = { pt_br: ptBr, en_us: enUs }

export function addi18n(): void {
    i18n.add(localeFiles[locale])
}

const hasPermissionToView =
    authorization.superAdmin ||
    authorization.admin ||
    authorization.Permission.ADMIN ||
    authorization.Permission.OGPERFORMANCE_MANAGE_KPI ||
    authorization.Permission.OGPERFORMANCE_ADMINISTRATE_KPI ||
    authorization.Permission.OGPERFORMANCE_VIEW_KPI

export const DataPersistenceConfiguration = {
    async setup(): Promise<void> {
        if (hasPermissionToView) {
            Router.route(
                'config/dynamic-dashboard-status',
                WrapperDynamicDashboardGlobalSendPage,
                'dynamic-dashboard-status',
                {}
            )
        }
    }
}
